module.exports = __webpack_public_path__ + "img/knue_gallery1.e635fa5b.jpg";